import { IFSMMachine, IFSMState, IFSMTransition } from '@src/slide/infrastructure/module/independent/state-machine/state-machine.interface';

export default class FSMState implements IFSMState {
    /**
     * 状态名称
     */
    public name: string;
    /**
     * 当前的状态机
     */
    public fsmMachine: IFSMMachine;
    public duration: number;
    public transitions: Array<IFSMTransition> = [];
    /**
     * 当进入状态时调用的事件
     */
    public onEnter;
    /**
     * 当离开状态时调用的事件
     */
    public onExit;
    public constructor(name: string) {
        this.name = name;
    }

    public addTransition(transition: IFSMTransition): void {
        if (this.transitions.includes(transition)) return;
        this.transitions.push(transition);
    }

    public enterCallback(prev: IFSMState): void {
        this.onEnter?.(prev);
        // 重置计时器
        this.duration = 0;
    }

    public exitCallback(next: IFSMState): void {
        this.onExit?.(next);
        // 重置计时器
        this.duration = 0;
    }
}
